<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-title>
                <span class="subheading">
                  {{ item.tieude }} ?
                </span>
                <v-spacer/>
                <span class="text-body-2 font-italic mr-4">
                  <v-icon small>mdi-clock</v-icon>
                  {{item.created_at_text}}
                </span>
                <span class="text-body-2 font-italic">
                  <v-icon small>mdi-eye</v-icon>
                  {{ countView || 1 }}
                </span>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-title class="subheading font-weight-bold justify-left">
                Hỏi:
              </v-card-title>
              <v-card-text>
                <div v-html="item.noidung"/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="item.traloi">
          <v-col cols="12">
            <v-card flat>
              <v-card-title class="subheading font-weight-bold justify-left">
                Đáp:
              </v-card-title>
              <v-card-text>
                <div id="qas_content" v-html="item.traloi"/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        sm="12"
        md="4"
      >
        <v-card flat class="text-center">
          <v-card-text>
            <span class="text-h6">
              Thông tin khác
            </span>
          </v-card-text>
        </v-card>
        <v-card flat v-for="(relatedItem, index) in relatedItems" 
          :to="{ name: 'SupportView', params: { id: relatedItem.id }}"
          :key="index"
          class="px-6"
        >
          <div class="d-flex flex-no-wrap">
            <v-avatar
              class="ma-3 rounded-lg"
              size="100"
              tile
            >
              <v-img
                src="@/assets/hoi-dap-nong-nghiep.jpg"
              />
            </v-avatar>
            <div>
              <v-card-title class="text-h6">
                {{relatedItem.tieude}}
              </v-card-title>
              <v-card-subtitle>
                <v-icon small>mdi-clock</v-icon>
                <span class="font-italic">{{relatedItem.created_at_text}}</span>
                <span class="px-1"/>
                <v-icon v-if="relatedItem.traloi" color="success" small>mdi-checkbox-marked-circle-outline</v-icon>
                <v-icon v-else color="orange" small>mdi-clock-time-four-outline</v-icon>
                <span class="ml-1 font-italic">{{ relatedItem.traloi ? 'Đã trả lời' : 'Đang chờ' }}</span>
              </v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import { mapActions } from 'vuex';
  import SystemSevice from '@/services/System';
  export default {
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      crumbs: [],
      item: {},
      relatedItems: [],
      countView: 0,
    }),
    watch: {
      "$route.params.id": function() {
        this.initialize();
      }
    },
    mounted() {
      this.initialize();
      SystemSevice.setSiteViewLocal({
        name: `SupportView@${this.$route.params.id}`,
      });
      this.viewCount();
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      initialize(){
        const app = this;
        app.getLoader(true);
        axios.get(`api/v1/public/supports/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            app.crumbs = [
              {
                text: 'Trang chủ',
                disabled: false,
                href: '/',
              },
              {
                text: 'Hỏi đáp kỹ thuật',
                disabled: false,
                href: '/supports',
              },
              {
                text: app.item.tieude,
                disabled: true
              }
            ];
            app.getRelatedItems();
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getRelatedItems(){
        axios.get(`api/v1/public/supports-related/${this.$route.params.id}`)
          .then(response => {
            this.relatedItems = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      viewCount(){
        axios.get(`api/v1/public/get-site-detail-counter/SupportView@${this.$route.params.id}`)
          .then(response => {
            this.countView=response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    }
  }
</script>
<style>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
  .cara .v-image__image--cover {
    background-size: contain;
  }
  .basil {
    background-color: #FFFBE6 !important;
  }
  .basil--text {
    color: #356859 !important;
  }
  #qas_content .ql-align-center{
    text-align: center;
  }
  #qas_content img {
    width: 50%;
  }
</style>